import { render, staticRenderFns } from "./DashBoardPerformance.vue?vue&type=template&id=2f818877&scoped=true"
import script from "./DashBoardPerformance.vue?vue&type=script&lang=js"
export * from "./DashBoardPerformance.vue?vue&type=script&lang=js"
import style0 from "./DashBoardPerformance.vue?vue&type=style&index=0&id=2f818877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f818877",
  null
  
)

export default component.exports